"use strict";
// packages/types/src/chapterSnapshot.ts
Object.defineProperty(exports, "__esModule", { value: true });
